import {ServiceBase} from '../../ServiceBase';
import {IServiceFactoryExtended} from '../../service-factory-extended.interface';
import {IMessageBrokerService} from './message-broker.service.interface';
import {IMessageBroker, MessageBroker} from '@sparkware/uc-sdk-core';
import {STANDARD_TOPIC_HEADER} from './message-broker.consts';

export class MessageBrokerService extends ServiceBase implements IMessageBrokerService {
    constructor(services: IServiceFactoryExtended) {
        super(services);
        this.channels = new MessageBroker(services.logger);
        this.reaction(() => this.services.user.isAuthorized ,
            (isAuthorized) => {
                if(isAuthorized) {
                    this.channels.identity.topics.loginSuccess.publish(STANDARD_TOPIC_HEADER, {});
                } else {
                    this.channels.identity.topics.logoutSuccess.publish(STANDARD_TOPIC_HEADER, {});
                }
            });
    }



    readonly channels: IMessageBroker;
}